module.exports = __webpack_public_path__ + "static/media/HOME-image7.2c08c7ed.png";